// Route-Funktion für Creator-Profile — `/@:handle` mit literalem `@`.
//
// Filesystem-Routing allein (`pages/@handle/+Page.tsx`) ergibt `/:handle`
// und matched jeden einsegmentigen Pfad — inklusive `/datastories` ohne
// `@` und `/s/...` kurzzeitig. Eine Route-String-Variante (`/@:handle`)
// hat in Vike 0.4.235 den `@` nicht sauber aus dem Parameter gestrippt.
//
// Die Route-Funktion hier ist präzise: sie matched **ausschließlich**
// Pfade der Form `/@<handle>` und liefert den reinen Handle ohne `@`
// als Parameter. Alles andere (inkl. `/datastories`, `/foo/bar`) lässt
// sie Vike an andere Pages weiterreichen — wenn keiner matched, landet
// die Request auf der 404-Seite.

import type { RouteSync } from "vike/types";

export const route: RouteSync = (pageContext) => {
  const url = pageContext.urlPathname ?? "";
  const match = url.match(/^\/@([^/]+)\/?$/);
  if (!match) return false;
  return {
    routeParams: { handle: match[1] },
  };
};
